export type HomeDesktopStatement = {
  enabled: boolean;
  line1Ar: string;
  line1En: string;
  line2Ar: string;
  line2En: string;
  bodyAr: string;
  bodyEn: string;
  ctaLabelAr: string;
  ctaLabelEn: string;
  ctaHref: string;
  mediaUrl: string;
};

export type HomeDesktopSpotlight = {
  enabled: boolean;
  productHandle: string;
  /** منتجات بديلة يختار منها الزائر فتتبدّل الصور والتعريف آلياً. */
  altHandles: string[];
  mediaUrl: string;
  notesAr: string;
  notesEn: string;
  ctaLabelAr: string;
  ctaLabelEn: string;
  showUpgrade: boolean;
  upgradeHandle: string;
};

export type HomeDesktopFragrances = {
  enabled: boolean;
  titleAr: string;
  titleEn: string;
  handles: string[];
};

export type HomeDesktopOutro = {
  captionAr: string;
  captionEn: string;
  /** رابط اختياريّ تحت النصّ (مثلاً /about أو /shop). */
  href: string;
};

export type HomeDesktopConfig = {
  statement: HomeDesktopStatement;
  spotlight: HomeDesktopSpotlight;
  fragrances: HomeDesktopFragrances;
  outro: HomeDesktopOutro;
};


export const HOME_DESKTOP_KEY = "home_desktop_editorial";

export const HOME_DESKTOP_DEFAULTS: HomeDesktopConfig = {
  statement: {
    enabled: true,
    line1Ar: "",
    line1En: "",
    line2Ar: "",
    line2En: "",
    bodyAr: "",
    bodyEn: "",
    ctaLabelAr: "",
    ctaLabelEn: "",
    ctaHref: "",
    mediaUrl: "",
  },
  spotlight: {
    enabled: true,
    productHandle: "",
    altHandles: [],
    mediaUrl: "",
    notesAr: "",
    notesEn: "",
    ctaLabelAr: "",
    ctaLabelEn: "",
    showUpgrade: true,
    upgradeHandle: "",
  },
  fragrances: {
    enabled: true,
    titleAr: "",
    titleEn: "",
    handles: [],
  },
  outro: {
    captionAr: "",
    captionEn: "",
    href: "",
  },
};

const str = (v: unknown, max: number) =>
  typeof v === "string" ? v.slice(0, max) : "";
const bool = (v: unknown, fb: boolean) => (typeof v === "boolean" ? v : fb);

export function normalizeHomeDesktopConfig(raw: unknown): HomeDesktopConfig {
  const o = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
  const s = (o.statement && typeof o.statement === "object" ? o.statement : {}) as Record<string, unknown>;
  const p = (o.spotlight && typeof o.spotlight === "object" ? o.spotlight : {}) as Record<string, unknown>;
  const f = (o.fragrances && typeof o.fragrances === "object" ? o.fragrances : {}) as Record<string, unknown>;
  const u = (o.outro && typeof o.outro === "object" ? o.outro : {}) as Record<string, unknown>;
  const d = HOME_DESKTOP_DEFAULTS;

  return {
    statement: {
      enabled: bool(s.enabled, d.statement.enabled),
      line1Ar: str(s.line1Ar, 200),
      line1En: str(s.line1En, 200),
      line2Ar: str(s.line2Ar, 200),
      line2En: str(s.line2En, 200),
      bodyAr: str(s.bodyAr, 600),
      bodyEn: str(s.bodyEn, 600),
      ctaLabelAr: str(s.ctaLabelAr, 80),
      ctaLabelEn: str(s.ctaLabelEn, 80),
      ctaHref: str(s.ctaHref, 500) || d.statement.ctaHref,
      mediaUrl: str(s.mediaUrl, 800).trim(),
    },
    spotlight: {
      enabled: bool(p.enabled, d.spotlight.enabled),
      productHandle: str(p.productHandle, 200).trim(),
      altHandles: Array.isArray(p.altHandles)
        ? p.altHandles
            .map((h) => str(h, 200).trim())
            .filter((h) => h.length > 0)
            .slice(0, 6)
        : [],
      mediaUrl: str(p.mediaUrl, 800).trim(),
      notesAr: str(p.notesAr, 800),
      notesEn: str(p.notesEn, 800),
      ctaLabelAr: str(p.ctaLabelAr, 80),
      ctaLabelEn: str(p.ctaLabelEn, 80),
      showUpgrade: bool(p.showUpgrade, d.spotlight.showUpgrade),
      upgradeHandle: str(p.upgradeHandle, 200).trim(),
    },
    fragrances: {
      enabled: bool(f.enabled, d.fragrances.enabled),
      titleAr: str(f.titleAr, 200),
      titleEn: str(f.titleEn, 200),
      handles: Array.isArray(f.handles)
        ? f.handles
            .map((h) => str(h, 200).trim())
            .filter((h) => h.length > 0)
            .slice(0, 8)
        : [],
    },
    outro: {
      captionAr: str(u.captionAr, 400),
      captionEn: str(u.captionEn, 400),
      href: str(u.href, 500),
    },
  };
}
